import { selectBoxIsTrue } from 'poly-js-utils/src/utils';

export const profileProductsListFilter = (profileProductsList, filterKey = 'product_title') => (product) => {
    return profileProductsList.includes(product[filterKey]);
};

export const selectProductsListFromProfileSelections = ({ profile, theme_data }) => {
    const isProductOfferingUseCanonicalName = selectBoxIsTrue(theme_data.is_product_offering_use_canonical_name);
    const productFilterKey = isProductOfferingUseCanonicalName ? 'product_canonical_name' : 'product_title';
    const profileProductsList = profile.products;
    const themeProducts = theme_data.product_offerings || theme_data.products_page.products || [];
    if (profileProductsList && profileProductsList.length) {
        return themeProducts.filter(profileProductsListFilter(profileProductsList, productFilterKey));
    }
    return themeProducts;
};



// WEBPACK FOOTER //
// ./components/product_list/selectors.js